import SessionQrPanelActionTypes from '../actions/session-qr-panel-action-types';

const initialState = {
  loading: false,
  qr: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SessionQrPanelActionTypes.LOAD_SESSION_QR_START:
    case SessionQrPanelActionTypes.GENERATE_SESSION_QR_START:
      return {
        ...state,
        loading: true
      };
    case SessionQrPanelActionTypes.LOAD_SESSION_QR_END:
      return {
        ...state,
        loading: false,
        qr: action.payload?.qr ?? null
      };
    case SessionQrPanelActionTypes.GENERATE_SESSION_QR_END:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};
